import React from 'react';
import { HelpCircle } from 'lucide-react';
import './HelpFloatingButton.css';

interface Props {
  onClick: () => void;
}

export default function HelpFloatingButton({ onClick }: Props) {
  return (
    <button
      className="help-fab"
      onClick={onClick}
      title="Hilfe öffnen"
      aria-label="Hilfe öffnen"
    >
      <HelpCircle size={24} />
    </button>
  );
}
